const HomePage = () => {
  return (
    <>
      <img src={"parcours-avenir.svg"} style={{maxWidth: "100%"}} alt={"orientation"}/>
    </>
  );
};

export default HomePage;
